module.exports = __webpack_public_path__ + "img/icon_badge_f.c6a98047.svg";